var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.state === 'boolean')?_c('v-icon',{attrs:{"color":_vm.state ? 'success' : 'error'}},[_vm._v(" "+_vm._s(_vm.state ? 'check' : 'block')+" ")]):_c('span',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }